interface SectionHeadingProps {
  index: string;
  eyebrow: string;
  title: string;
  desc?: string;
  actionLabel?: string;
}

export default function SectionHeading({
  index,
  eyebrow,
  title,
  desc,
  actionLabel,
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
      <div className="max-w-2xl">
        <div className="flex items-center gap-3 mb-3">
          <span className="w-7 h-7 rounded-md bg-foreground-950 text-background-50 text-xs font-label font-medium flex items-center justify-center">
            {index}
          </span>
          <span className="text-xs font-label tracking-[0.25em] text-primary-700 uppercase">
            {eyebrow}
          </span>
        </div>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-snug">
          {title}
        </h2>
        {desc ? (
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
            {desc}
          </p>
        ) : null}
      </div>
      {actionLabel ? (
        <a
          href="#board"
          className="inline-flex items-center gap-2 shrink-0 whitespace-nowrap text-sm font-label text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer"
        >
          {actionLabel}
          <i className="ri-arrow-right-line text-base w-4 h-4 flex items-center justify-center" />
        </a>
      ) : null}
    </div>
  );
}